import { NO_EPG_ID } from '$/epg/programs'
import { ONE_SECOND_MS } from '@/constants/time'
import { type EpgInfo, type TvChannel } from '@setplex/tria-api'
import { subHours } from 'date-fns'
import { MAX_REWIND_BACK_HOURS, type LiveProgramInfo } from './index.h'

const formatStartTime = ({
  actualStartMs,
  epgId,
}: Readonly<EpgInfo>): number => {
  const start =
    NO_EPG_ID === epgId
      ? subHours(new Date(), MAX_REWIND_BACK_HOURS).getTime()
      : actualStartMs
  return start / ONE_SECOND_MS
}

export const formatToView = ({
  channel,
  program,
}: {
  channel: Readonly<TvChannel>
  program: Readonly<EpgInfo>
}): LiveProgramInfo => {
  return {
    logoUrl: channel.logoUrl,
    channelId: channel.id,
    channelTitle: `${channel.channelNumber}. ${channel.name}`,
    programId: program.id,
    programTitle: program.name,
    description: program.description,
    actualStartMs: program.actualStartMs,
    actualStopMs: program.actualStopMs,
    startTime: formatStartTime(program),
  }
}
